import { getIndexes } from "common/utils";

export function getError(str){
    const parts = str.match(/%ERR:\s+(.*)/)
    if(parts){
        return parts[1];
    }else{
        return str;
    }
}

export function parseSystemSoftwareDetail(input){
    const [header, ...rows] = input.trim().split("\n");
    const headerIndex = getIndexes(header);
    const softwareBqnId = {};
    const softwareList = [];

    for(let row of rows){
        const attrs = row.trim().split(/\s+/);
        const item = {
            bqn: attrs[headerIndex["BQN"]],
            name: attrs[headerIndex["NAME"]],
            version: attrs[headerIndex["VERSION"]],
            active: attrs[headerIndex["ACTIVE"]],
            boot: attrs[headerIndex["BOOT"]],
        }

        softwareList.push(item);

        const key = `${item.name}-${item.version}`;

        if(softwareBqnId[key]){
            softwareBqnId[key].push(item.bqn);
        }else{
            softwareBqnId[key] = [item.bqn];
        }
    }

    return {softwareBqnId, softwareList};
}

export const checkActivationAllowed = (name, version, softwareDetail, bqnId, loginBqnId, mode) => {
    function output(reloadAllowed, forceStandalone){
      return {
        reloadAllowed,
        forceStandalone
      }
    }

    if (name !== "bqn" || !version.match(/R4\.\d+/)) {
      return output(true, false)
    }

    if (!softwareDetail) {
      console.error("softwareDetail not loaded");
      return output(false, false)
    }

    const currentBqnSoftware = softwareDetail.find(
      (item) =>
        Number(item.bqn) === Number(bqnId !== "all" ? bqnId : loginBqnId) &&
        item.name === "bqn" &&
        item.active === "yes"    
    );

    if (!currentBqnSoftware) {
      console.error("Current BQN software version not found");
      return output(false, false)
    }

    const releaseMatch = currentBqnSoftware.version.match(/R(\d+)\.\d+/);

    if (!releaseMatch) {
      console.error("No current software release found");
      return output(false, false)
    }

    if (Number(releaseMatch[1]) < 5) {
      return output(true, false)
    }

    if(mode === "standalone"){
      return output(true, true)
    }else{
      return output(false, false)
    }
  };

  export const removeClusterConfigurationText = "You must remove the cluster configuration before going to an R4 version";

  export const showRemoveClusterConfigurationWarning = () => {
    showModalConfirm(
          "Cluster configuration warning",
          removeClusterConfigurationText,
          "",
          () => {
            return;
          },
          () => {
            return;
          },
          "OK",
          ""
        );
  }

  export const sendForceStandalone = (bqnId, next) => {
    return ifCl.run(`system bqn id ${bqnId} standalone force`).then(() => {
      return next();
    });
  };
